// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce .easycommerce-order-input {
    border: 1px solid var(--color-ec-border);
}
.easycommerce .easycommerce-order-input:focus {
    outline: 0;
    border: 1px solid var(--color-ec-primary);
    box-shadow: none;
}
.easycommerce .easycommerce-order-input.error {
    outline: 0;
    border: 1px solid #f44336;
    box-shadow: none;
}
.easycommerce .easycommerce-order-select:hover,
.easycommerce .easycommerce-order-select:active,
.easycommerce .easycommerce-order-select:focus,
.easycommerce .easycommerce-new-order-attribute:hover,
.easycommerce .easycommerce-new-order-attribute:focus,
.easycommerce .easycommerce-new-order-attribute:active {
    color: var(--color-ec-body);
    outline: 0;
    box-shadow: none;
    border: 1px solid var(--color-ec-body);
}
.easycommerce .easycommerce-new-order-attribute {
    border: 1px solid var(--color-ec-border);
    border-radius: 6px;
}
.easycommerce .easycommerce-order-select {
    transition: 0.3s all ease;
}
.easycommerce .easycommerce-order-select:focus,
.easycommerce .easycommerce-order-select:hover {
    border: 1px solid var(--color-ec-primary);
}
`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/pages/Orders/style.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;AAC5C;AACA;IACI,UAAU;IACV,yCAAyC;IACzC,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,yBAAyB;IACzB,gBAAgB;AACpB;AACA;;;;;;IAMI,2BAA2B;IAC3B,UAAU;IACV,gBAAgB;IAChB,sCAAsC;AAC1C;AACA;IACI,wCAAwC;IACxC,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;AACA;;IAEI,yCAAyC;AAC7C","sourcesContent":[".easycommerce .easycommerce-order-input {\n    border: 1px solid var(--color-ec-border);\n}\n.easycommerce .easycommerce-order-input:focus {\n    outline: 0;\n    border: 1px solid var(--color-ec-primary);\n    box-shadow: none;\n}\n.easycommerce .easycommerce-order-input.error {\n    outline: 0;\n    border: 1px solid #f44336;\n    box-shadow: none;\n}\n.easycommerce .easycommerce-order-select:hover,\n.easycommerce .easycommerce-order-select:active,\n.easycommerce .easycommerce-order-select:focus,\n.easycommerce .easycommerce-new-order-attribute:hover,\n.easycommerce .easycommerce-new-order-attribute:focus,\n.easycommerce .easycommerce-new-order-attribute:active {\n    color: var(--color-ec-body);\n    outline: 0;\n    box-shadow: none;\n    border: 1px solid var(--color-ec-body);\n}\n.easycommerce .easycommerce-new-order-attribute {\n    border: 1px solid var(--color-ec-border);\n    border-radius: 6px;\n}\n.easycommerce .easycommerce-order-select {\n    transition: 0.3s all ease;\n}\n.easycommerce .easycommerce-order-select:focus,\n.easycommerce .easycommerce-order-select:hover {\n    border: 1px solid var(--color-ec-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
